import { combineReducers } from "redux";
import authReducer from "./authReducer";
import employeeReducer from "./employeeReducer";
import attendanceReducer from "./attendanceReducer";
import leaveReducer from "./leaveReducer";
import dashboardReducer from "./dashboardReducer";
import taskReducer from "./taskReducer";
import tasksTitleReducer from "./tasksTitleReducer";
import holidayReducer from "./holidayReducer";
import roleReducer from "./roleReducer";
import geofenceReducer from "./geofenceReducer";
import taskTrackingReducer from "./taskTrackingReducer";
import locationReducer from "./locationReducer";
import VisitLocationReducer from "./VisitLocationReducer"; 
import userReducer from "./userReducer";
import userBulkUploadReducer from "./userBulkUploadReducer";
import leaveTypeReducer from "./leaveTypeReducer";
import designationReducer from "./designationReducer";
import districtsReducer from "./districtsReducer";
import municipalitiesReducer from "./municipalitiesReducer";
import adminReducer from "./AdminReducer"; 
import parkGeofenceReducer from "./parkGeofenceReducer"; 
import applyLeaveReducer from "./applyLeaveReducer";
import searchEmployeeReducer from "./SearchEmployeeReducer";
import taskAdminReducer from "./CreateTasksAdminReducer"; 
import parkAdminBulkUploadReducer from "./parkAdminBulkUploadReducer";
import parkUserBulkUploadReducer from "./parkUserBulkUploadReducer";
import adminParkReducer from "./AdminParkReducer";
import parkUserReducer from "./parkEmployeeReducer";
import parkAttendanceReducer from "./parkAttendanceReducer";
import parkDetailsReducer from "./ParkdetailsReducer";
import dashboardParkReducer from "./dashboardParkkReducer"; 
import parkEmployeeCreateReducer from "./parkEmployeeCreateReducer"; 
import flashMessageReducer from "./flashMessageReducer";

const rootReducer = combineReducers({
  auth: authReducer,
  employee: employeeReducer,
  attendance: attendanceReducer,
  leave: leaveReducer,
  dashboard: dashboardReducer,
  task: taskReducer,
  tasksTitle: tasksTitleReducer,
  holiday: holidayReducer,
  role: roleReducer,
  geofence: geofenceReducer,
  taskTracking: taskTrackingReducer,
  location: locationReducer,
  VisitLocation: VisitLocationReducer,
  User: userReducer,
  userBulkUpload: userBulkUploadReducer,
  leaveType: leaveTypeReducer,
  designation: designationReducer,
  districtsData: districtsReducer,
  municipalitiesData: municipalitiesReducer,
   admin: adminReducer,
   parkGeofence: parkGeofenceReducer, 
  // admin: adminReducer,
  applyLeave: applyLeaveReducer,
  // searchEmployee: searchEmployeeReducer,
   employeeSearch: searchEmployeeReducer,
   taskAdmin: taskAdminReducer,
   parkAdminBulkUpload: parkAdminBulkUploadReducer,
   parkUserBulkUpload: parkUserBulkUploadReducer,
   adminPark: adminParkReducer,
   parkUsers: parkUserReducer,
   parkAttendance: parkAttendanceReducer,
   parkDetails: parkDetailsReducer,
   dashboardPark: dashboardParkReducer,
   parkEmployeeCreate: parkEmployeeCreateReducer, 
   flashMessages: flashMessageReducer,
});

export default rootReducer;
